import p from './consumer-account-log.vue';

export default p;
